import { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, Route, Redirect } from 'react-router-dom';
import { WithTranslation, withTranslation } from 'react-i18next';

import { UnauthorizedPagesContainer, NotificationBox } from '~src/outer_modules/shared/shared.sc';
import { logout } from '~src/store/session/actions';
import { suspendedMessageDisplayed } from '~src/store/app/actions';
import PrimaryButton from '~src/shared/buttons/basicButtons/PrimaryButton.sc';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import { routes } from '~src/routingConfig';
import { StoreI } from '~src/rootReducer';

import { Title, Description, ButtonsBox } from './accountSuspended.sc';

interface StateProps {
  accountSuspended: boolean;
}

interface DispatchProps {
  doLogout(): void;
  suspendedMessageDisplayed(): void;
}

type Props = StateProps & DispatchProps & WithTranslation & RouteComponentProps<any>;

const AccountSuspended: FC<Props> = props => {
  useEffect(() => {
    props.doLogout();
    return props.suspendedMessageDisplayed;
  }, []);

  const goToContact = () => props.history.push(routes.contact);
  const goToLogin = () => props.history.push(routes.login);

  const renderContent = () =>
    props.accountSuspended ? (
      <UnauthorizedPagesContainer>
        <NotificationBox>
          <Title data-translation="x.company.account_suspended.title">
            {props.t('x.company.account_suspended.title')}
          </Title>
          <Description data-translation="x.company.account_suspended.description">
            {props.t('x.company.account_suspended.description')}
          </Description>
          <ButtonsBox>
            <PrimaryButton data-translation="x.company.account_suspended.go_to_support" onClick={goToContact}>
              {props.t('x.company.account_suspended.go_to_support')}
            </PrimaryButton>
            <SecondaryButton data-translation="x.company.account_suspended.go_to_login" onClick={goToLogin}>
              {props.t('x.company.account_suspended.go_to_login')}
            </SecondaryButton>
          </ButtonsBox>
        </NotificationBox>
      </UnauthorizedPagesContainer>
    ) : (
      <Redirect to={routes.login} />
    );

  return <Route render={renderContent} />;
};

const mapState2Props = ({ user }: StoreI): StateProps => ({
  accountSuspended: user.session.accountSuspended,
});

const mapDispatch2Props = (dispatch: any): DispatchProps => ({
  doLogout: () => dispatch(logout),
  suspendedMessageDisplayed: () => dispatch(suspendedMessageDisplayed),
});

const AccountSuspendedT = withTranslation()(AccountSuspended);

const AccountSuspendedC = connect(mapState2Props, mapDispatch2Props)(AccountSuspendedT);

export default AccountSuspendedC;
